import { Card, SingleDatePicker, Tabs } from '@sede-enterprise/shell-ds-react-framework'
import React, { useState } from 'react'
import momentGenerateConfig from 'rc-picker/lib/generate/moment'
import PageData from './PageData'
import UserData from './UserData'
import moment from 'moment'
import { handleDateChange } from '../../util/handleDateChange'

const DEFAULT_STATS_SPEC = {
    initStart: moment().subtract(2, "year"),
    initEnd: moment(),
};

const UsageStatistics = ({ selectedSite }) => {
    const [startDate, setStartDate] = useState(DEFAULT_STATS_SPEC.initStart);
    const [endDate, setEndDate] = useState(DEFAULT_STATS_SPEC.initEnd);


    const [startErrorText, setStartErrorText] = useState(null);
    const [inValidStartDate, setInValidStartDate] = useState(null);

    const [endErrorText, setEndErrorText] = useState(null);
    const [inValidEndDate, setInValidEndDate] = useState(null);

    return (
        <div className='parent-container'>
            <div className='content-container'>
                <div className='chart-date-container'>
                    <div className='start-date-wrapper'>
                        <p className="data-label">Start Date</p>
                        <SingleDatePicker
                            generateConfig={momentGenerateConfig}
                            config="custom"
                            format="DD/MM/yyyy"
                            disabledDate={(curr) => curr ? curr.isAfter(moment().toDate()) : false}
                            value={!inValidStartDate && startDate ? startDate : inValidStartDate ? inValidStartDate : null}
                            onChange={(date) => {
                                setStartErrorText(null)
                                setInValidStartDate(null)
                                if (date.isBefore(endDate)) {
                                    handleDateChange(date, startDate, setStartDate, "DD/MM/yyyy")
                                }
                                else if (date.isAfter(endDate)) {
                                    setStartErrorText("Start date cannot be after end date")
                                    setInValidStartDate(date)
                                }
                            }
                            }
                            allowClear={false} />
                        <p className="data-label error-label">{startErrorText}</p>
                    </div>
                    <div className='end-date-wrapper'>
                        <p className="data-label">End Date</p>
                        <SingleDatePicker
                            generateConfig={momentGenerateConfig}
                            config="custom"
                            format="DD/MM/yyyy"
                            disabledDate={(curr) => curr ? curr.isAfter(moment().toDate()) : false}
                            value={!inValidEndDate && endDate ? endDate : inValidEndDate ? inValidEndDate : null}
                            onChange={(date) => {
                                setEndErrorText(null)
                                setInValidEndDate(null)
                                if (date.isAfter(startDate)) {
                                    handleDateChange(date, endDate, setEndDate, "DD/MM/yyyy")
                                }
                                else if (date.isBefore(startDate)) {
                                    setEndErrorText("End date cannot be before start date")
                                    setInValidEndDate(date)
                                }
                            }
                            }
                            allowClear={false} />
                        <p className="data-label error-label">{endErrorText}</p>
                    </div>
                </div>
                <br />
                <Card bodyPadding={false} className='asset-chart-body'>
                    <Tabs tabBarStyle={
                        {
                            borderBottom: '1px solid #E0E0E0',
                        }
                    }
                        items={[
                            {
                                label: 'Pages',
                                key: 'pages',
                                children: <PageData selectedSite={selectedSite} startDate={startDate} endDate={endDate} />
                            },

                            {
                                label: 'Users',
                                key: 'users',
                                children: <UserData selectedSite={selectedSite} startDate={startDate} endDate={endDate} />
                            }

                        ]}
                    />
                </Card>
            </div>
        </div>
    )
}

export default UsageStatistics